import { render, staticRenderFns } from "./handOverTask.vue?vue&type=template&id=864ee342&scoped=true&"
import script from "./handOverTask.vue?vue&type=script&lang=js&"
export * from "./handOverTask.vue?vue&type=script&lang=js&"
import style0 from "./handOverTask.vue?vue&type=style&index=0&id=864ee342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864ee342",
  null
  
)

export default component.exports